"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxySelect = exports.WarningBanner = exports.InfoBanner = exports.Header = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const select_1 = __importDefault(require("@kyruus/select"));
const ui_theme_1 = require("@kyruus/ui-theme");
const Banners_1 = require("../Banners");
exports.Header = styled_1.default.h4 `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.InfoBanner = (0, styled_1.default)(Banners_1.InfoBanner) `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.WarningBanner = (0, styled_1.default)(Banners_1.WarningBanner) `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.ProxySelect = (0, styled_1.default)(select_1.default) `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
`;
//# sourceMappingURL=styles.js.map